// @ vendors
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/RAConstants/actionTypes');

const parseProducts = products => {
    let formattedProducts = {};

    products.forEach(product => {
        formattedProducts[product.product.typeOfProduct] = {
            managementType: product.product.managementType,
            assetAllocations: product.assetAllocations,
        };
    });

    return formattedProducts;
};

const initialState = Immutable.fromJS({
    portfolio: {},
    comparative: {},
    isFetching: false,
    error: null,
    patrimony: {
        discretional: {
            amount: 0,
            percentage: 0,
        },
        own: {
            amount: 0,
            percentage: 0,
        },
        total: 0,
    },
    roboAccount: {
        name: '',
        owner: '',
        contract: {
            contractNumber: '',
            productNumber: '',
        },
        ibanComplex: {},
    },
    roboAdvisor: {
        assetAllocation: [],
        keyFigures: {
            valuation: 0,
            cashBalance: 0,
            securitiesValuation: 0,
            investedAmount: 0,
            timeWeightedReturn: 0,
            simpleReturn: 0,
            netReturn: 0,
            netMarketReturn: 0,
            dividends: 0,
            taxes: 0,
            fees: 0,
            maxWithdrawalAmount: 0,
            deposits: 0,
            withdrawals: 0,
        },
    },
    hasRoboHired: false,
    hasRoboCancelled: false,
});

const RAPortfolioDistribution = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_FAILURE:
            return state.merge({
                error: action.payload.error,
                isFetching: false,
            });
        case actionTypes.RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_REQUEST:
            return state.merge({
                isFetching: true,
                error: false,
            });
        case actionTypes.RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_SUCCESS:
            return state.mergeDeep({
                portfolio: parseProducts(action.payload.portfolio),
                isFetching: false,
            });
        case actionTypes.RA_PORTFOLIO_DISTRIBUTION_RESET_PORTFOLIO:
            return initialState;
        default:
            return state;
    }
};

module.exports = RAPortfolioDistribution;
